import { initializeApp } from "firebase/app";
import { AnalyticsOptions } from "./AnalyticsOptions";
import { AnalyticsHandler } from "./IAnalyticsHandler";
import { firebaseConfig } from "../firebase";
import { getAnalytics, logEvent } from "firebase/analytics";

export class FirebaseOptions extends AnalyticsOptions {}

export class FirebaseAnalyticsHandler extends AnalyticsHandler {
  private analytics: any;

  constructor() {
    super();

    this.initialize();
  }

  protected initialize(): void {
    const enviroment: "development" | "production" | "test" =
      process.env.NODE_ENV;
    const app: any = initializeApp(firebaseConfig[enviroment]);
    getAnalytics(app);

    const analytics = getAnalytics();
    this.analytics = analytics;
  }

  public log(logEventTag: string, options: any[]): void {
    const firebaseOptions = new FirebaseOptions(options);
    logEvent(this.analytics, logEventTag, ...firebaseOptions.values);
  }
}
